import React from 'react';
import { PageComponentProps } from '@sharefiledev/sharefile-appshell';

const AsyncLegacyTokenInterceptor = React.lazy(
	() => import('../components/LegacyTokenInterceptor')
);

const ServiceTeams = React.lazy(() => import('../components/ServiceTeams'));

export const ServiceTeamsPage: React.FC<PageComponentProps> = ({
	piral,
	...componentProps
}) => (
	<React.Suspense fallback={<div data-testid="loading-legacy-token-interceptor" />}>
		<AsyncLegacyTokenInterceptor piral={piral} {...componentProps}>
			<ServiceTeams />
		</AsyncLegacyTokenInterceptor>
	</React.Suspense>
);
